import { blueprintTextState } from '@/utils/blueprintText.ts';
import type { SuiteDraft } from '@/context/SuiteDraftContext/SuiteDraftContext.ts';
import type { SuiteBlueprintProposal } from '@/types/automationSuites.ts';

export async function suiteProposal(draft: SuiteDraft): Promise<SuiteBlueprintProposal> {
  const state = blueprintTextState(draft.body);
  if (state.error) throw new Error(state.error.replaceAll('Version blueprint', 'Suite blueprint'));
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(state.normalized));
  return {
    expected_head_revision: draft.head,
    expected_blueprint_revision_id: draft.revisionId,
    expected_body_sha256: Array.from(new Uint8Array(digest), (byte) =>
      byte.toString(16).padStart(2, '0'),
    ).join(''),
    body: state.normalized,
  };
}
